import {Component} from "../../../gvf/js/component";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";

export class BodyComponent extends Component{
    constructor(scope,$root){
        super(scope,$root);
    }

    ready(){
        if(this.$root.data("popup-message")){
            swal(
                {
                    type: "info",
                    title: "",
                    text: this.$root.data("popup-message")
                }
            );
        }
        //tooltips functionality
        GvfUiService.ready("[data-toggle=\"tooltip\"]",($element)=>{
            $element.tooltip();
        });
    }
}
